import { create } from 'zustand';

export const useMobileAppPromptModalStore = create((set) => ({
  isOpen: false,
  openMobileAppPromptModal: () => set({ isOpen: true }),
  closeMobileAppPromptModal: () => set({ isOpen: false }),
}));
